export const callToActionI18NDe = {
    enjoyedUsingTimepot: "Hat Ihnen Timepot gefallen?",
    createAccount: "Jetzt Ihr eigenes Konto erstellen",
    createAccountShort: "Konto erstellen",
    or: "oder",
    sendFeedback: "Feedback übermitteln",
    signUpNow: "Jetzt anmelden!",
};
